'use strict';

import template from './template.html';
import modalTemplate from './modal-template.html';
import { resolveCurrentPosition } from '../../log/add';


export default function($interval, $log, $uibModal) {
	'ngInject';

	return {
		require: '^incident',
		scope: {
			logEntry: '<',
		},
		link: link,
		template: template,
	};

	function link(scope, element, attrs, $incident) {
		const label = element.parent();
		label.addClass('btn-rest');
		scope.$incident = $incident;
		var input = angular.element(element.find('input')[0]);
		input.on('change', function() {
			if (label.hasClass('busy')) return;
			label.addClass('busy');
			$log.debug('File input modified, opening the preview modal');
			var modal = $uibModal.open({
				scope: scope,
				template: modalTemplate,
				controller: modalCtrl,
				controllerAs: 'ctrl',
				resolve: {
					position: getCurrentPosition,
				}
			});
			modal.opened.finally(function() {
				label.removeClass('busy');
			});
		});
	}
}


function getCurrentPosition($log, $window, $q) {
	'ngInject';

	var deferred = $q.defer();
	deferred.promise.then(function(position) {
		return position;
	});
	resolveCurrentPosition(deferred);
	return deferred.promise;
}


function modalCtrl($scope, $log, $window, $q, $uibModalInstance, Upload, toastr) {
	'ngInject';

	let vm = this;
	let $incident = $scope.$parent.$incident;

	$scope.$parent.$watch('fileToUpload', function(file) {
		if (file) {
			vm.title = file.name;
			vm.description = '';
			vm.isImage = !!/^image/.exec(file.type);
		}
	});

	vm.abort = function() {
		$log.debug('Photo upload aborted by user');
		vm.worker.abort();
		vm.uploading = false;
	}

	vm.upload = function() {
		if (vm.uploading) return;
		vm.uploading = true;

		var data = {
			file: $scope.$parent.fileToUpload,
			title: vm.title,
			description: vm.description,
		};

		if ($scope.logEntry) {
			data.log_entry_event = $scope.logEntry.event;
			data.log_entry_message = $scope.logEntry.message;
			if (data.log_entry_event == 'geo:arrived') {
				data.title = 'Arrival photo';
			}
			if (data.log_entry_event == 'geo:departed') {
				data.title = 'Departure photo';
			}
			try {
				data.log_entry_lat = $scope.$resolve.position.coords.latitude.toFixed(8);
				data.log_entry_lng = $scope.$resolve.position.coords.longitude.toFixed(8);
			} catch(e) {
				console.log(e);
			}
		}

		// Perform the upload to the server
		vm.worker = Upload.upload({
			url: `/api/incident/${$incident.uuid}/files/`,
			method: 'POST',
			data: data,
		});
		vm.worker.then(handleUploadSuccess, handleUploadError, handleUploadProgress).finally(() => {
			vm.uploading = false;
		});
	}

	function handleUploadSuccess(response) {
		$uibModalInstance.close();
		toastr.success('File uploaded');
	}

	function getErrorMessage(error) {
		try {
			if (error.data.file.length > 0) {
				return error.data.file[0];
			}
		} catch (e) {
			$log.error('Failed to get error message', e);
		}
		return 'Could not upload file';
	}

	function handleUploadError(error) {
		vm.uploading = false;
		$log.error('Failed to upload file');
		$log.debug(error);
		toastr.error(getErrorMessage(error));
	}

	function handleUploadProgress(e) {
		vm.uploading = true;
		vm.progress = Math.min(100, parseInt(100.0*e.loaded/e.total));
	}
}
